import React from 'react';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Loader2 } from 'lucide-react';

export const FeatureGate = ({ flag, children, fallback = null }) => {
  const { enabled, loading } = useFeatureFlag(flag);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
      </div>
    );
  }
  
  if (!enabled) {
    return fallback || (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Coming Soon</h1>
          <p className="text-gray-600">This feature is not yet available.</p>
        </div>
      </div>
    );
  }
  
  return children;
};

export default FeatureGate;
